/* eslint-disable @repo/internal/react/require-jsdoc */
import React from 'react';

export const Spacing = () => (
	<svg
		width="285"
		height="160"
		viewBox="0 0 285 160"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g>
			<path
				d="M103.655 79.5315C103.645 86.397 105.456 93.1422 108.902 99.0803H176.453C179.887 93.1431 181.695 86.4056 181.695 79.547C181.695 72.6883 179.887 65.9508 176.453 60.0137H108.902C105.461 65.9427 103.651 72.6766 103.655 79.5315Z"
				fill="#FCA700"
			/>
			<path
				d="M142.675 118.552H181.69V99.0649H176.453C173.028 104.992 168.104 109.913 162.175 113.333C156.245 116.754 149.52 118.554 142.675 118.552Z"
				fill="#1868DB"
			/>
			<path
				d="M108.902 99.0649H103.639V118.552H142.675C135.83 118.553 129.106 116.753 123.178 113.333C117.249 109.912 112.326 104.991 108.902 99.0649Z"
				fill="#1868DB"
			/>
			<path
				d="M142.675 118.552C149.52 118.554 156.245 116.754 162.174 113.333C168.104 109.913 173.028 104.992 176.453 99.0649H108.902C112.326 104.991 117.249 109.912 123.178 113.333C129.106 116.753 135.83 118.553 142.675 118.552Z"
				fill="var(--color-fill)"
			/>
			<path
				d="M142.675 40.5112H103.639V59.9982H108.902C112.326 54.0718 117.249 49.151 123.178 45.7304C129.106 42.3097 135.83 40.5097 142.675 40.5112Z"
				fill="#1868DB"
			/>
			<path
				d="M181.69 40.5112H142.675C149.52 40.5093 156.245 42.3091 162.175 45.7298C168.104 49.1504 173.028 54.0714 176.453 59.9982H181.695L181.69 40.5112Z"
				fill="#1868DB"
			/>
			<path
				d="M142.675 40.5112C135.83 40.5097 129.106 42.3097 123.178 45.7304C117.249 49.151 112.326 54.0718 108.902 59.9982H176.453C173.028 54.0714 168.104 49.1504 162.174 45.7298C156.245 42.3091 149.52 40.5093 142.675 40.5112Z"
				fill="var(--color-fill)"
			/>
			<path
				d="M153.303 94.5942C152.311 94.359 151.293 94.2433 150.273 94.2496C149.8 94.2496 148.807 93.9769 147.413 93.9306C147.184 93.9223 146.954 93.9395 146.729 93.982C145.655 94.166 144.567 94.2607 143.477 94.265C143.633 93.1279 143.71 91.9814 143.709 90.8337C143.652 89.1669 143.416 88.7502 143.441 87.6184C143.441 85.7047 143.76 82.474 143.838 81.7024C143.848 81.5877 143.848 81.4723 143.838 81.3577C143.796 80.5346 143.622 76.9181 143.704 73.8108C143.704 71.6142 143.704 70.2509 143.704 69.541C143.71 68.1463 143.595 66.7538 143.359 65.3792C143.333 65.2437 143.262 65.1207 143.159 65.0293C144.27 64.9779 145.782 64.9367 147.161 64.983H150.247C151.268 64.9919 152.285 64.8761 153.278 64.6384C153.792 64.5201 153.792 63.522 153.278 63.3986C152.285 63.1627 151.268 63.0487 150.247 63.059C149.774 63.059 148.781 62.7812 147.387 62.7349C147.158 62.7266 146.928 62.7439 146.703 62.7864C145.223 63.0206 143.725 63.1119 142.227 63.059H136.862H134.732C133.823 63.0523 132.916 63.142 132.026 63.3266C131.465 63.4449 131.465 64.5921 132.026 64.7155C132.916 64.9001 133.823 64.9897 134.732 64.983C135.946 64.9316 136.25 64.6898 137.078 64.7155C138.521 64.7686 139.96 64.9025 141.389 65.1168C141.473 65.1271 141.557 65.1271 141.641 65.1168L142.253 65.0808C142.173 65.1625 142.119 65.2665 142.099 65.3792C141.863 66.7538 141.748 68.1463 141.754 69.541C141.754 70.1943 141.476 71.5525 141.43 73.4713C141.423 73.7827 141.442 74.0942 141.487 74.4025C141.718 76.4413 141.807 78.4937 141.754 80.5449C141.754 80.5449 141.754 85.7253 141.754 87.9117C141.754 89.5579 141.754 90.3501 141.754 90.8337C141.749 91.9762 141.824 93.1177 141.98 94.2496H134.783C133.874 94.2469 132.968 94.3383 132.077 94.5222C131.517 94.6405 131.517 95.7877 132.077 95.9112C132.968 96.0932 133.875 96.1828 134.783 96.1787C135.997 96.1273 136.301 95.8855 137.129 95.9112C138.573 95.9642 140.012 96.0982 141.44 96.3125C141.524 96.3228 141.609 96.3228 141.692 96.3125C142.289 96.2713 144.923 96.0964 147.192 96.1787H150.278C151.299 96.185 152.316 96.0693 153.308 95.834C153.818 95.7157 153.818 94.7177 153.303 94.5942Z"
				fill="var(--color-gestural-line)"
			/>
		</g>
	</svg>
);
